import styled from 'styled-components'

export const CentralToolbarSection = styled.div`
flex: 1;
& li a {
  padding-left: 0.5em;
  padding-right: 0.5em;
}
`

export const LeftToolbarSection = styled.div`
overflow-x:hidden;
div[dir=ltr][class=lang] & {
  margin-right: 0.5em;
}

div[dir=rtl][class=lang] & {
  margin-left: 0.5em;
}
`

export const RightToolbarSection = styled.div`
display: flex;
margin-top: "auto";
margin-bottom: "auto";
align-self: stretch;
align-items: stretch;
`

export const NavPanel = styled.div`
display: flex;
align-items: center;
flex-direction: row;
margin: 0;
color: #fff;
height: 3em;
min-height: 3em;
background-color: #4D4D4D;
& a {
  color: #fff;
  text-decoration: none;    
}

@media screen and (min-width: 500px) {
  & a {
    font-size: 1.25em;
  }
}

@media screen and (max-width: 499px) {
  & a {
    font-size: 1.15em;
  }
}
`